const formatPrice = (price: string | number) => {
  if (price) {
    const liras = price
      .toString()
      .split('.')[0]
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.');

    const cents: any = price.toString().split('.');

    let cent;
    if (cents[1]) cent = cents[1].substring(0, 2);

    return {
      liras: liras,
      cents: cent,
    };
  }
};

export default formatPrice;
